import React from 'react';
import { SidebarItem, Typography } from 'lib/cortiUI';
export const SidebarOrganizationItem = ({ selected, organization, onClick }) => {
    const handleSelectActiveOrg = () => onClick(organization.id);
    return (React.createElement(SidebarItem, { size: "small", selected: selected, justifyContent: "space-between", display: "flex", onClick: handleSelectActiveOrg },
        React.createElement(Typography, { variant: "body1" }, organization.name)));
};
